<template>
  <div
    class="input-select d-block"
    v-on-clickaway="closeSelect" >
    <label
      v-if="label"
      @click="closeSelect">
      {{ label }} <span v-if="rules.required" class="warning-color">*</span>
    </label>
    <div
      :class="{required: shouldShowError}"
      @click="openListOnClick"
      class="input-like"
      tabindex="0"
      @focus="openListOnFocus">
      <span v-if="cmpTextValue.text === ''">Select</span>
      <span v-else
        :class="['',
          (darkText ? 'dark-text':''),
          ((countryFlag && cmpTextValue != '') ? 'cut-text-calc' : 'cut-text'),
        ]">
        {{ shouldTranslate ? $t(cmpTextValue.text) : cmpTextValue.text }}
      </span>
      <CountryFlag
        class="select-flag"
        v-if="countryFlag && cmpTextValue != ''"
        :country="cmpTextValue.countryFlag"
        size='normal' />
      <Icon
        class="icon"
        name="arrowDown"
        size="28" />
    </div>
    <div
      v-show="isListOpened"
      :class="listPosition"
      class="options-list"
      ref="selectReference">
      <input
        ref="searchField"
        v-show="options.length > showSearch"
        class="search"
        v-model="search"
        @keydown="searchIt"
        :placeholder="$t('Search...')" />
      <ul>
        <li
          @keydown.prevent="nextItem"
          tabIndex="-1"
          v-for="(item, index) in filteredList"
          :key="`option-${index}`"
          :class="{active: indexItem === index}"
          :ref="`${randomSelectId}-${index}-opt`"
          @click.prevent="changeValue(index, item)">
          <Checkbox
            v-if="multiSelect"
            :value="preselected.indexOf(String(item.value)) > -1"
            class="m-r-10" />
          {{ shouldTranslate ? $t(item.text) : item.text }}
          <CountryFlag
            v-if="countryFlag && item.country != '' && item.country != undefined"
            :country="item.country"
            class="" size='normal' style="position: absolute;right: 10px;"/>
          <input :value="item.value" type="checkbox" style="display: none;"/>
        </li>
      </ul>
    </div>
    <span v-if="shouldShowError" class="warning-color validation-span" style="font-size: 12px;">{{ $t(errorMsg) }} {{ errorMsgAdditional }}</span>
  </div>
</template>

<script>
/* eslint-disable */
import { directive as onClickaway } from 'vue-clickaway';
import CountryFlag from 'vue-country-flag';
import Checkbox from '@/components/elements/inputs/checkbox';
import rules from "@/mixins/rules";

export default {
  name: 'InputSelect',
  mixins: [rules],
  directives: {
    onClickaway: onClickaway,
  },
  components: {
    CountryFlag, Checkbox,
  },
  props: {
    shouldTranslate: {
      type: Boolean,
      default: true,
    },
    log: {
      type: Boolean,
      default: false,
    },
    multiSelect: {
      type: Boolean,
      default: false,
    },
    parentContainerHeight: {
      type: [String, Number],
      default: '0',
    },
    options: {
      type: Array,
      default: function () {
        return [];
      },
    },
    darkText: {
      type: Boolean,
      default: false,
    },
    countryFlag: {
      type: Boolean,
      default: false,
    },
    renderCustomText: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Select option',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Boolean, Array],
      default: '',
    },
    showSearch: {
      type: Number,
      default: 7,
    },
    preselected: {
      type: Array,
      deafult: () => {
        return [];
      },
    },
  },
  data() {
    return {
      indexItem: 0,
      isListOpened: false,
      openedOnClick: false,
      search: '',
      listPosition: 'bottom',
      multiSelectArray: [],
    };
  },
  computed: {
    filteredList() {
      if(this.options.length < 1) return [];
      let selectedList = this.options.filter(option => {
        if(option.hasOwnProperty('selected')){
          if(!option.selected) return option;
        } else {
          return option;
        }
      });
      return selectedList.filter(option => {
        return option.text.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    cmpTextValue() {
      if(this.multiSelect){
        const arrayResult = [];
        if(this.preselected.length > 0){
          this.options.forEach((item) => {
            if(this.preselected.indexOf(String(item.value)) > -1){
              arrayResult.push(this.shouldTranslate ? this.$t(item.text) : item.text)
            }
          });
        }

        return {
          text: this.preselected.length > 0 ? arrayResult.join(', ') : 'Select',
          countryFlag: this.countryFlag ? this.options.filter(opt => opt.value == this.value)[0].country : '',
        }
      }
      if(this.value === undefined) return ''; //Ovo prekontrolisi || this.value === null
      if( (this.value !== '') && (this.options.length > 0) ) {
        this.options.filter((opt, index) => {
          if(opt.value == this.value) this.indexItem = index;
        });
        if (!this.options.filter(opt => opt.value == this.value)[0]) {
          return '';
        }
        let text = this.options.filter(opt => opt.value == this.value)[0].text || '';
        if(text === ''){
          return '';
        } else {
          return {
            text: this.options.filter(opt => opt.value == this.value)[0].text,
            countryFlag: this.countryFlag ? this.options.filter(opt => opt.value == this.value)[0].country : '',
          };
        }
      }
      return '';
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
  },
  methods: {
    searchIt(event) {
      if(event.keyCode == 9) this.closeSelect();
      if (event.keyCode == 38 || event.keyCode == 40) {
      	this.nextItem(event);
      } else {
        this.indexItem = 0;
        // this.search = event.target.value;
      }
    },
    nextItem (event) {
      if(event.keyCode == 9) this.closeSelect();
    	if (event.keyCode == 38 && this.indexItem > 0) {
      	this.indexItem--;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 40 && this.indexItem < this.options.length - 1) {
      	this.indexItem++;
        this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
      } else if (event.keyCode == 13) {
      	this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].click();
      }
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    changeValue(index, option) {
      if( !this.multiSelect ){
        this.indexItem = index;
        this.isListOpened = false;
        this.openedOnClick = false;
        this.$emit('changeCustom', option);
        this.$emit('change', option.value);
        this.$emit('input', option.value);
        this.search = '';
      } else {
        this.onChange(null, option);
      }
    },
    closeSelect() {
      this.isListOpened = false;
      this.openedOnClick = false;
      this.search = '';
    },
    calculatePosition() {
      if( this.$parent.$refs.popupContent !== undefined){
        const dropdownPosition = this.$refs.selectReference.getBoundingClientRect();
        const parentBox = this.$parent.$refs.popupContent.getBoundingClientRect();

        if(dropdownPosition.top + dropdownPosition.height > parentBox.bottom){
          this.listPosition = 'top';
        } else {
          this.listPosition = 'bottom';
        }

      } else {
        const dropdownPosition = this.$refs.selectReference.getBoundingClientRect();
        if(dropdownPosition.top + dropdownPosition.height > window.innerHeight){
          this.listPosition = 'top';
        } else {
          this.listPosition = 'bottom';
        }
      }
    },
    openListOnClick() {
      if(this.openedOnClick) {
        this.closeSelect();
        return;
      }
      this.isListOpened = true;
      this.openedOnClick = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    openListOnFocus() {
      this.isListOpened = true;
      this.$nextTick(() => {
        if( this.filteredList.length > 0) {
          this.$refs[`${this.randomSelectId}-${this.indexItem}-opt`][0].focus();
        }
        if( this.filteredList.length > this.showSearch){
          this.$refs.searchField.focus();
        }
      });
    },
    onChange(val, item) {
      const newArray = [...this.preselected];
      if(newArray.indexOf(item.value) > -1){
        newArray.splice(newArray.indexOf(item.value), 1);
      } else {
        newArray.push(item.value);
      }

      this.$emit('change', newArray);
      this.$emit('input', newArray);
    },
  },
}
</script>
